import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { JetAssignmentsProvider } from './context/JetAssignmentsProvider'
import { JetAssignmentsMain } from './components/JetAssignmentsMain'

export const JetAssignments = () => {
  return (
    <NuqsAdapter>
      <JetAssignmentsProvider>
        <JetAssignmentsMain />
      </JetAssignmentsProvider>
    </NuqsAdapter>
  )
}
